import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IPerson } from "src/app/interfaces";

@Component({
    selector: "circ-people-select",
    templateUrl: "./people-select.component.html",
    styleUrls: ["./people-select.component.scss"],
    standalone: false
})
export class PeopleSelectComponent {
  @Input() public data: IPerson[];
  @Input() public disabled = false;
  @Input() public noDataText = "";
  @Input() public placeholder = "Placeholder";
  @Input() public loading = false;
  @Input() public maxPeople = null;

  @Output() public blur = new EventEmitter<Event>();
  @Output() public open = new EventEmitter<Event>();
  @Output() public close = new EventEmitter<Event>();
  @Output() public focus = new EventEmitter<Event>();
  @Output() public valueChange = new EventEmitter<IPerson[]>();
  @Output() public filterChange = new EventEmitter<string>();

  @Input() public value: IPerson[];

  public onValueChange(value: IPerson[]): void {
    value = value ?? [];
    if (value.length > 1 && this.maxPeople && this.maxPeople < value.length) {
      value = value.slice(1);
      this.value = value;
    }
    this.valueChange.emit(value);
  }
}
